import {RefObject, useCallback} from 'react'

import {DataObjectId, User} from 'yougile-model'
import {Sync} from '@client/sync'
import {UserInfoCard} from '@components/user-info-card'

export interface UseOnAvatarClickOptions {
  userId?: DataObjectId
  ref: RefObject<Element>
  withUserInfo?: boolean
}

export interface UseOnAvatarClick {
  onClick: () => void
}

export const useOnAvatarClick = ({
  userId,
  ref,
  withUserInfo
}: UseOnAvatarClickOptions): UseOnAvatarClick => {
  const onClick = useCallback(() => {
    if (withUserInfo && userId) {
      const u = Sync.getCurrentSandbox().get(userId) as User
      if (u && ref.current) {
        const r = ref.current.getBoundingClientRect()
        UserInfoCard.show(u, r.left + r.width / 2, r.top + r.height)
      }
    }
  }, [ref, userId, withUserInfo])

  return {onClick}
}
